<app-gallery-modal></app-gallery-modal>

<lib-spinner>
  <router-outlet></router-outlet>
</lib-spinner>
